var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"border":"1px solid #ccc","padding":"15px","background-color":"#f5f5f5"}})
}
var staticRenderFns = []

export { render, staticRenderFns }